import { render, staticRenderFns } from "./edit-template.vue?vue&type=template&id=380ad3ea&scoped=true"
import script from "./edit-template.vue?vue&type=script&lang=js"
export * from "./edit-template.vue?vue&type=script&lang=js"
import style0 from "./edit-template.vue?vue&type=style&index=0&id=380ad3ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380ad3ea",
  null
  
)

export default component.exports